import React from "react";
import moment from "moment";

const TodayDateActionBar = (props) => {
    const { onToday } = props;

    const todayLabel = moment().format("dddd, MMMM D, YYYY");

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                padding: "8px 0",
            }}
        >
            <button
                onClick={onToday}
                style={{
                    background: "transparent",
                    border: "none",
                    borderBottom: "2px solid #1976d2",
                    color: "#1976d2",
                    cursor: "pointer",
                    fontWeight: 500,
                    fontSize: "13px",
                    padding: "2px 0",
                }}
            >
                {todayLabel}
            </button>
        </div>
    );
};

export default TodayDateActionBar;
